
import NavClass from './NavClass';
import TabClass from './TabClass';

import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Plus, Target, Info, CheckCircle, PlusCircle  } from 'react-feather';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { Breadcrumbs, H5, Btn } from '../../../AbstractElements';
import { AddNewTask, AddTask, Close, ToDo,pinagareAPIURL } from '../../../Constant';
import TodoContext from '../../../_helper/Todo';
import TodoCheckbox from './TodoCheckbox';
import TodoList from './TodoList';
import ApplicationSideBar from './ApplicationSideBar';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ReactApexChart from 'react-apexcharts';
//import { todayProgressData } from '../../../Data/OnlineCourse/ChartData';
import TodayProgress from './TodayProgress';
import ActivityCard from './ActivityCard';
import { ToastContainer, toast } from "react-toastify";
import { trackPromise } from 'react-promise-tracker';


const Task = () => {
	
  const { addNewTodo } = useContext(TodoContext);
  const [addTask, setAddTask] = useState('');
  const [task, setTask] = useState('');
  const [nextProgressStep,setNextProgressStep] = useState('Awaits Review');
  const [isPrepopulatedDataIn, setIsPrepopulatedDataIn] = useState(false);
  const [percentCompleted, setPercentCompleted] = useState(10);
  const [processedSoFar, setProcessedSoFar] = useState(15);
  const history = useNavigate();
  const {scheme_application_id} =useParams();
  //localStorage.setItem("percentCompleted",null);

  const initTimelineData = [
    {
      title: 'Application Submitted By Employee',
      subTitle: '8th March, 2024',
      time: '5 days ago',
      dis: 'The application will go through review by HR, Accounting Officer then Board Evaluation',
      color: 'primary',
    },
   
  ];
  const [timelineData, setTimelineData] = useState(initTimelineData);

  
  const initTodayProgressData = {
    series: [100, percentCompleted],
    options: {
      chart: {
        width: 240,
        height: 360,
        type: "radialBar",
        offsetX: -28,
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              offsetY: 20,
              color: "var(--chart-text-color)",
              fontFamily: "Rubik, sans-serif",
              fontWeight: 500,
            },
            value: {
              fontSize: "22px",
              offsetY: -16,
              fontFamily: "Rubik, sans-serif",
              fontWeight: 500,
              color: "var(--chart-text-color)",
            },
            total: {
              show: true,
              label: "Processed!",
              fontSize: "12px",
              color: "var(--chart-text-color)",
              formatter: diraUpdateProgress,
            },
          },
          hollow: {
            margin: 5,
            size: "70%",
            image: null,
            imageWidth: 115,
            imageHeight: 115,
            imageClipped: false,
          },
          track: {
            background: "transparent",
          },
        },
      },
      colors: ["var(--theme-default)", "#FFA941"],
      labels: ["Submitted by Employee", "Review Progress"],
      stroke: {
        lineCap: "round",
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        offsetY: -15,
        fontSize: "14px",
        fontFamily: "Rubik, sans-serif",
        fontWeight: 500,
        labels: {
          colors: "var(--chart-text-color)",
        },
        markers: {
          width: 6,
          height: 6,
        },
      },
      responsive: [
        {
          breakpoint: 1830,
          options: {
            chart: {
              offsetX: -40,
            },
          },
        },
        {
          breakpoint: 1750,
          options: {
            chart: {
              offsetX: -50,
            },
          },
        },
        {
          breakpoint: 1661,
          options: {
            chart: {
              offsetX: -10,
            },
          },
        },
        {
          breakpoint: 1530,
          options: {
            chart: {
              offsetX: -25,
            },
          },
        },
        {
          breakpoint: 1400,
          options: {
            chart: {
              offsetX: 10,
            },
          },
        },
        {
          breakpoint: 1300,
          options: {
            chart: {
              offsetX: -10,
            },
          },
        },
        {
          breakpoint: 1200,
          options: {
            chart: {
              width: 255,
            },
          },
        },
        {
          breakpoint: 992,
          options: {
            chart: {
              width: 245,
            },
          },
        },
        {
          breakpoint: 600,
          options: {
            chart: {
              width: 225,
            },
          },
        },
      ],
    },
  };
  initTodayProgressData.options.plotOptions.radialBar.dataLabels.total.formatter=diraUpdateProgress;
  //initTodayProgressData.options.plotOptions.radialBar.dataLabels.total.formatter(processedSoFar);
  const [todayProgressData, setTodayProgressData] = useState(initTodayProgressData);

  const openTaskWrapper = () => {
    setAddTask(' visible');
    document.getElementById('addTaskBtn').classList.add('hide');
  };
  const closeTaskWrapper = () => {
    setAddTask('');
    document.getElementById('addTaskBtn').classList.remove('hide');
  };
  const onTaskChanged = (e) => {
    setTask({
      task: e.currentTarget.value,
    });
  };
  const addNewTask = () => {
    if (task === '') {
      document.getElementById('newtask').classList.remove('border-danger');
      document.getElementById('newtask').classList.add('border-danger');
    } else {
      addNewTodo(task);
      setAddTask(' visible');
      setTask('');
      document.getElementById('newtask').value = '';
      document.getElementById('newtask').classList.add('taskmag-hide');
      document.getElementById('newtask').classList.remove('taskmag-show');
      document.getElementById('addTaskBtn').classList.add('hide');
    }
  };

  
    //const soFar = () => {
    //return processedSoFar+"%";
  //}

  function diraUpdateProgress(){//alert(processedSoFar+"-uu-"+param);

    if(localStorage.getItem("percentCompleted")!=null) return localStorage.getItem("percentCompleted")+"%";
    else return processedSoFar+"%";

  }

  useEffect(() => {

   
    if(!isPrepopulatedDataIn){

      localStorage.setItem("percentCompleted",null);
    
      const body_t=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'track_pinagare_scheme_application',
        application_id:scheme_application_id,       
        
      });
      trackPromise(
         pinagareFetchRequest(pinagareAPIURL,body_t,'track_pinagare_scheme_application')
      );  
  
    }
//alert(percentCompleted+"--"+processedSoFar);
setPercentCompleted(percentCompleted);
setProcessedSoFar(processedSoFar);  

    var thisProgressData = {
      series: [100, percentCompleted],
      options: {
        chart: {
          width: 240,
          height: 360,
          type: "radialBar",
          offsetX: -28,
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                offsetY: 20,
                color: "var(--chart-text-color)",
                fontFamily: "Rubik, sans-serif",
                fontWeight: 500,
              },
              value: {
                fontSize: "22px",
                offsetY: -16,
                fontFamily: "Rubik, sans-serif",
                fontWeight: 500,
                color: "var(--chart-text-color)",
              },
              total: {
                show: true,
                label: "Processed!",
                fontSize: "12px",
                color: "var(--chart-text-color)",
                formatter: diraUpdateProgress,
              },
            },
            hollow: {
              margin: 5,
              size: "70%",
              image: null,
              imageWidth: 115,
              imageHeight: 115,
              imageClipped: false,
            },
            track: {
              background: "transparent",
            },
          },
        },
        colors: ["var(--theme-default)", "#FFA941"],
        labels: ["Submitted by Employee", "Review Progress"],
        stroke: {
          lineCap: "round",
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          offsetY: -15,
          fontSize: "14px",
          fontFamily: "Rubik, sans-serif",
          fontWeight: 500,
          labels: {
            colors: "var(--chart-text-color)",
          },
          markers: {
            width: 6,
            height: 6,
          },
        },
        responsive: [
          {
            breakpoint: 1830,
            options: {
              chart: {
                offsetX: -40,
              },
            },
          },
          {
            breakpoint: 1750,
            options: {
              chart: {
                offsetX: -50,
              },
            },
          },
          {
            breakpoint: 1661,
            options: {
              chart: {
                offsetX: -10,
              },
            },
          },
          {
            breakpoint: 1530,
            options: {
              chart: {
                offsetX: -25,
              },
            },
          },
          {
            breakpoint: 1400,
            options: {
              chart: {
                offsetX: 10,
              },
            },
          },
          {
            breakpoint: 1300,
            options: {
              chart: {
                offsetX: -10,
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                width: 255,
              },
            },
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                width: 245,
              },
            },
          },
          {
            breakpoint: 600,
            options: {
              chart: {
                width: 225,
              },
            },
          },
        ],
      },
    };

    thisProgressData.options.plotOptions.radialBar.dataLabels.total.formatter=diraUpdateProgress;//=>{return processedSoFar+"%";};
    //thisProgressData.series[1]=percentCompleted;
   
    setTodayProgressData(thisProgressData);

    

      
  }, [processedSoFar,percentCompleted]);

  async function pinagareFetchRequest(url,body,eng) {
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((respose) => {
          if (respose.ok) {
           
            return respose.json();
            //alert('success --1--');
          }
          throw new Error('error')
        })
        .then((data) => {
          //alert('success --2--');
          //console.log(JSON.stringify(data));
          
          if (data.status!=undefined&&data.status===true) {
            //alert('success --3--');
            if(data.eng==='track_pinagare_scheme_application'&&data.eng!=undefined){

              //alert('success --4--');

            if(data.userHasApplied&&data.stages_details!=undefined){//alert(JSON.stringify(data));

              //alert('success --5--');
              
              setTimelineData(data.stages_details);
              const len=data.stages_details.length-1;//console.log(len+' - arr len');

              //console.log(data.stages_details);

              //alert(data.stages_details[len].percentage+"---"+localStorage.getItem("percentCompleted"));

              setNextProgressStep(data.stages_details[len].next_stage);
              setPercentCompleted(data.stages_details[len].percentage);
              setProcessedSoFar(data.stages_details[len].percentage);
              localStorage.setItem("percentCompleted", data.stages_details[len].percentage);
                
              setIsPrepopulatedDataIn(true);
              //toast.success("User fetch Successful..."); 
              

            }
            else{

              //redirect

              //toast.error("User has not applied. Redirecting to Home...");

              //history(`${process.env.PUBLIC_URL}/dpsm/home`);

            }

           
          }else{
            //alert('none');
          }
         

                          
          } else {

            if (data.status!=null&&data.status===false) {
             // toast.error(data.message);
            }
            else{
              //toast.error("Data Fetch error occurred..."+JSON.stringify(data)+"---"+eng);
            }

            setIsPrepopulatedDataIn(false);

          }
        })
    } catch (error) {
     
      toast.error("Making Data Fetch Request failed..."+JSON.stringify(error)+"---"+eng);
      setIsPrepopulatedDataIn(false);
   }
  }



  return (
    <Fragment>
      <Breadcrumbs mainTitle='Leadership Transformation Programme' parent='Home' title='Programme / Track Application' />
      <Container fluid={true} className='email-wrap bookmark-wrap todo-wrap'>
	   
        <Row>
		 <Col xl='3' className='xl-30 box-col-12'>
      <div className='md-sidebar'>
          <TodayProgress nextProgressStep ={nextProgressStep} todayProgressData  ={todayProgressData} percentCompleted={percentCompleted} processedSoFar={processedSoFar}  />
		  </div></Col>

          <Col xl='9' className='xl-70 box-col-12'>
            <Card>
              <CardHeader className='d-flex align-items-center justify-content-between'>
                <H5>{"My Application"}</H5>
                <div className='d-flex align-items-center gap-3'>
                  <div className='todo'>
                    
                  </div>
                 
				                    
                </div>
              </CardHeader>
              <CardBody style={{alignItems: "center !impotant",justifyContent: "center !impotant", width:'100%'}}>
                <div className='todo' style={{alignItems: "center !impotant",justifyContent: "center !impotant"}}>
                  <div className='todo-list-wrapper' style={{alignItems: "center !impotant",justifyContent: "center !impotant"}}>
                    <div className='todo-list-container todo-list-footer' style={{alignItems: "center !impotant",justifyContent: "center !impotant"}}>
                     
                      <ActivityCard timelineData={timelineData} />
					  
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
  
  
};

export default Task;